import { render, staticRenderFns } from "./AgencyDetailCard.vue?vue&type=template&id=4e9a974c&scoped=true&"
import script from "./AgencyDetailCard.vue?vue&type=script&lang=js&"
export * from "./AgencyDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./AgencyDetailCard.vue?vue&type=style&index=0&id=4e9a974c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a974c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow})
